module.exports = __webpack_public_path__ + "media/images/country_flags/jm-6c8aeb960fb2a90b6d4737c8097e53ec.png";